import { render } from "./ExercisesView.vue?vue&type=template&id=5588377b&scoped=true&ts=true"
import script from "./ExercisesView.vue?vue&type=script&lang=ts"
export * from "./ExercisesView.vue?vue&type=script&lang=ts"

import "./ExercisesView.vue?vue&type=style&index=0&id=5588377b&scoped=true&lang=css"

import exportComponent from "/srv/stamincasa/stamincasa-matematica/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5588377b"]])

export default __exports__